import api from './api';

export interface LocationResult {
  place_id: number;
  display_name: string;
  lat: string;
  lon: string;
  address?: {
    city?: string;
    town?: string;
    village?: string;
    state?: string;
    country?: string;
  };
}

export const locationService = {
  // Search locations through backend proxy
  searchLocations: async (query: string, limit: number = 5): Promise<LocationResult[]> => {
    if (!query.trim() || query.length < 3) {
      return [];
    }

    try {
      const response = await api.get('/api/location/search', {
        params: { q: query, limit },
      });
      return response.data?.results || [];
    } catch (error) {
      console.error('Error searching locations:', error);
      throw error;
    }
  },

  // Format location display name
  formatDisplayName: (result: LocationResult): string => {
    const parts = result.display_name.split(', ');
    if (parts.length > 3) {
      return `${parts[0]}, ${parts[parts.length - 3] || ''}, ${parts[parts.length - 1]}`.replace(/, ,/g, ',');
    }
    return result.display_name;
  },

  // Reverse geocode coordinates through backend proxy
  reverseGeocode: async (lat: number, lon: number): Promise<LocationResult | null> => {
    try {
      const response = await api.get('/api/location/reverse', {
        params: { lat, lon },
      });
      return response.data?.result || null;
    } catch (error) {
      console.error('Error reverse geocoding:', error);
      return null;
    }
  },
};
